import React, { useEffect, useState } from "react";
import tick from "../../Assets/svg/green-bg-tick.svg";
import Button from "../modules/Button";
import Timer from "../modules/Timer";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useDispatch } from "react-redux";
import { addTokenInfo } from "../LoginPage/redux/actions";
// import { Timer } from "@mui/icons-material";
import { useNavigate } from 'react-router-dom';

function Success() {
  const navigate = useNavigate()

  const dispatch = useDispatch();
  const [timeRemaining, setTimeRemaining] = useState(10);
  const setTr = (e) => {
    setTimeRemaining(e);
  };
  const resendText = () => {
    return (
      <div className="edit-text">
        <span
          className={`left-edit ${timeRemaining > 0 ? "disabled-text" : ""} `}
          onClick={() => {}}
        >
          Redirect In
        </span>
        {timeRemaining > 0 && (
          <span className="pointer right-edit">
            00:
            {<Timer limit={10} isTime={(e) => setTr(e)} time={timeRemaining} />}
          </span>
        )}
      </div>
    );
  };
  const toLoginScreen = () => {
    dispatch(addTokenInfo(["showToast", true]));
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url);
    navigate('/');

  };
  useEffect(() => {
    if (timeRemaining < 1) {
      toLoginScreen();
    }
  }, [timeRemaining]);
  return (
    <div className="cred-section success">
      <div className="tick-div">
        <img src={tick} alt="tick" />
        <div className="md-title">
          Congratulations! Your Account has been created successfully
        </div>
        <div className="md-desc">
          SignIn and continue your application process
        </div>
      </div>
      <Button
        //   disabled={
        //     (type === "regular" &&
        //       (registeredData?.info?.indian === null || count !== 100)) ||
        //     (type === "otp" && aadhar.otp.length !== 6)
        //   }
        onClickHandler={() => {
          toLoginScreen();
        }}
        value={"Continue to Sign In"}
        type={"contained"}
      />
      <Button
        //   disabled={!value}
        onClickHandler={() => {}}
        value={resendText()}
        type={"only-text"}
        disabled={true}
      />
    </div>
  );
}

export default Success;
